// extracted by mini-css-extract-plugin
module.exports = {"root":"index-module--root--GShdp","title":"index-module--title--1wKJw","animation":"index-module--animation--qQg8c","emailInput":"index-module--emailInput--2KPwl"};